<template>
  <div class="CollectStat">
    <div class="page-title">{{ title }}</div>
    <div class="flex">
      <div class="lt-area flex-auto">
        <div class="inline">
          <el-input
            v-model="search_word"
            class="input-with-select"
            size="mini"
            :placeholder="searchPlaceholder"
            :style="{ width: '300px' }"
            @keydown.enter.native="handleSearchWord"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearchWord"
            />
          </el-input>
        </div>
        <div class="search-container inline" />
        <div class="inline">
          <APeriodSelector
            ref="period"
            :value="search_period"
            hide-select
            @change="handleChangePeriod"
          />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
            >검색(F5)</el-button
          >
        </div>
      </div>
      <div class="rt-area flex-fixed align-right">
        <el-button
          icon="fas fa-file-excel fa-lg"
          style="padding: 8px;"
          circle
          @click="handleClickExcel"
        ></el-button>
      </div>
    </div>
    <ATable
      ref="table"
      v-loading="loading"
      :data="filterdData"
      :rowClassName="handleRowClassName"
      max-height="780px"
      hideTopPanel
      hide-button-insert
      hide-pagination
      highlight-current-row
      border
    >
      <el-table-column
        prop="pay_date"
        label="결제일"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="customer_name"
        label="거래처"
        show-overflow-tooltip
      />
      <el-table-column prop="location" label="사업장" show-overflow-tooltip />
      <el-table-column
        prop="pay_way_flag"
        label="결제 방법"
        width="120"
        :formatter="resolvePayWay"
      />
      <el-table-column
        prop="price"
        label="결제"
        class-name="cell-number"
        width="100"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="discount_price"
        label="할인액"
        width="120"
        class-name="cell-number"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="real_price"
        label="실수금액"
        width="120"
        class-name="cell-number"
        :formatter="util.numberFormat"
      />
      <el-table-column prop="desc" label="비고" show-overflow-tooltip />
    </ATable>
  </div>
</template>
<script>
import { account_form } from "@/common/mixins/account_form";

export default {
  name: "PayStat",
  mixins: [account_form],
  components: {},
  data() {
    return {
      title: this.$t("title.pay_stat"),
      searchPlaceholder: "거래처, 사업장",
      search_period: { value: "0d" },
      search_word: "",
      fixed_search_word: "",
      search_field: ["customer_name", "location"],
      search_service: true,
      period: {},
      loading: false,
      items: [],
    };
  },
  computed: {
    filterdData() {
      let items = this.util.filterMultiFields(
        this.items,
        this.search_field,
        this.fixed_search_word
      );
      return this.convert_data(items);
    },
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.api.listPayStat(this.period).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = this.getCustomerInfo(res.data);
      });
    },
    getCustomerInfo(items) {
      items.forEach((item) => {
        item.real_price = Number(item.price) - Number(item.discount_price);
      });
      return items;
    },
    convert_data(items) {
      let data = [];
      let old_day = "",
        new_day = "";
      let price_day = 0,
        discount_price_day = 0,
        real_price_day = 0;
      let price_total = 0,
        discount_price_total = 0,
        real_price_total = 0;
      for (let i = 0; i < items.length; i++) {
        data.push(items[i]);

        price_total += items[i].price;
        discount_price_total += items[i].discount_price;
        real_price_total += items[i].real_price;

        new_day = items[i].pay_date.slice(-2);
        if (old_day !== "" && old_day !== new_day) {
          // 일별 날짜가 바뀌는 구간으로 일별 "소계" 처리
          data.splice(data.length - 1, 0, {
            location: "소 계",
            pay_date: "",
            price: price_day,
            discount_price: discount_price_day,
            real_price: real_price_day,
            type_flag: "1",
          });
          price_day = 0;
          discount_price_day = 0;
          real_price_day = 0;

          price_day += items[i].price;
          discount_price_day += items[i].discount_price;
          real_price_day += items[i].real_price;
        } else {
          // 동일한 날짜의 정보 처리
          price_day += items[i].price;
          discount_price_day += items[i].discount_price;
          real_price_day += items[i].real_price;
        }
        // 제일 마지막 날짜의 "소계" 처리 및  "합계" 정보 처리
        if (i === items.length - 1) {
          data.splice(data.length, 0, {
            location: "소 계",
            pay_date: "",
            price: price_day,
            discount_price: discount_price_day,
            real_price: real_price_day,
            type_flag: "1",
          });

          data.splice(data.length + 1, 0, {
            location: "합 계",
            pay_date: "",
            price: price_total,
            discount_price: discount_price_total,
            real_price: real_price_total,
            type_flag: "2",
          });
        }
        old_day = new_day;
      }
      return data;
    },
    resolvePayWay(row, cell, value) {
      if (value == "2") {
        return this.getBankAccountName(row.account_id);
      }

      let pay_way = this.system.options.pay_way_flag.find((item) => {
        return item.value == value;
      });
      return pay_way ? pay_way.label : null;
    },
    handleRowClassName({ row }) {
      if (row.type_flag === "1") {
        return "day-row";
      } else if (row.type_flag === "2") {
        return "total-row";
      }
      return "";
    },
    handleClickExcel() {
      this.$refs.table.downloadExcel();
    },
    handleSearchWord() {
      this.fixed_search_word = this.search_word;
    },
  },
};
</script>

<style lang="scss">
.CollectStat {
  .search-container {
    margin-left: 10px;
  }
  .el-table .day-row {
    background: lightgray;
    text-align: center;
  }
  .el-table .total-row {
    background: lightgray;
    text-align: center;
    color: red;
    font-weight: bold;
  }
}
</style>
